import type React from 'react'
import { type ReactElement, useId } from 'react'

export function IconSpectra(props: React.SVGProps<SVGSVGElement>): ReactElement {
  const clipPathId = `spectra-clip-${useId().replace(/:/g, '')}`

  return (
    <svg width={30} height={31} viewBox={'0 0 30 31'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'} {...props}>
      <path
        d={
          'M15 30.5C23.3126 30.5 30 23.8126 30 15.5C30 7.18745 23.3126 0.5 15 0.5C6.68745 0.5 0 7.18745 0 15.5C0 23.8126 6.68745 30.5 15 30.5Z'
        }
        fill={'#00F99B'}
      />
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d={
            'M20.4842 8.23511H15.6032C11.7075 8.23511 8.54936 11.3932 8.54932 15.2889V17.1399C8.54932 17.1627 8.55838 17.1846 8.57452 17.2007C8.59066 17.2169 8.61255 17.2259 8.63537 17.2259H9.61959C9.66715 17.2259 9.70564 17.1874 9.70564 17.1399L9.70568 15.2889C9.70577 12.0319 12.3461 9.39147 15.6033 9.39147H22.191C22.2569 9.39147 22.298 9.32056 22.263 9.26477C21.888 8.66815 21.3266 8.23558 20.4857 8.23511H20.4842Z'
          }
          fill={'black'}
        />
        <path
          d={
            'M22.8899 11.0816C22.8865 11.0617 22.8761 11.0436 22.8607 11.0306C22.8452 11.0176 22.8256 11.0105 22.8055 11.0106H15.6035C13.1766 11.0106 11.2092 12.9779 11.2092 15.4048V17.14C11.2092 17.1629 11.2183 17.1847 11.2344 17.2009C11.2506 17.217 11.2725 17.2261 11.2953 17.2261H12.0213C12.0665 17.2261 12.1113 17.2172 12.1531 17.1999C12.1948 17.1826 12.2328 17.1572 12.2648 17.1253C12.2967 17.0933 12.3221 17.0553 12.3394 17.0136C12.3567 16.9718 12.3656 16.927 12.3656 16.8818V15.4048C12.3656 13.6166 13.8152 12.1669 15.6035 12.1669H22.9143C22.9635 12.1669 23.0027 12.1258 22.9999 12.0767C22.9839 11.7975 22.9523 11.4511 22.8899 11.0816ZM9.51586 22.7342H14.3968C18.2926 22.7342 21.4507 19.5761 21.4507 15.6804V13.8295C21.4507 13.8066 21.4417 13.7847 21.4255 13.7686C21.4094 13.7525 21.3875 13.7434 21.3647 13.7434H20.3804C20.3576 13.7434 20.3357 13.7525 20.3196 13.7686C20.3034 13.7847 20.2944 13.8066 20.2944 13.8295V15.6804C20.2943 18.9375 17.6539 21.5779 14.3969 21.5779H7.80922C7.74328 21.5779 7.70211 21.6487 7.73718 21.7046C8.1121 22.3012 8.67352 22.7337 9.51435 22.7342H9.51586Z'
          }
          fill={'black'}
        />
        <path
          d={
            'M7.1102 19.8878C7.11712 19.9289 7.15292 19.9588 7.19461 19.9588H14.3966C16.8235 19.9588 18.7908 17.9915 18.7908 15.5646V13.8293C18.7908 13.8065 18.7818 13.7846 18.7656 13.7685C18.7495 13.7524 18.7276 13.7433 18.7048 13.7433H17.9787C17.9335 13.7433 17.8888 13.7522 17.847 13.7695C17.8052 13.7868 17.7673 13.8121 17.7353 13.8441C17.7033 13.8761 17.678 13.914 17.6607 13.9558C17.6434 13.9976 17.6345 14.0423 17.6345 14.0875V15.5646C17.6345 17.3528 16.1848 18.8024 14.3966 18.8024H7.08572C7.03655 18.8024 6.99733 18.8435 7.00014 18.8926C7.01614 19.1718 7.04771 19.5182 7.1102 19.8878Z'
          }
          fill={'black'}
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width={16} height={16} fill={'white'} transform={'translate(7 7.5)'} />
        </clipPath>
      </defs>
    </svg>
  )
}
